import React, { useState, useEffect } from 'react'
import CSS from './DocSearch.module.scss'
import loadjs from 'loadjs'

const DOCSEARCH_JS_URL =
  'https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.js'

const DOCSEARCH_CSS_URL =
  'https://cdn.jsdelivr.net/npm/docsearch.js@2/dist/cdn/docsearch.min.css'

/**
 * Put me anywhere for a live search bar
 */

const DocSearch = props => {
  const { apiKey, indexName, debug, inputProps } = props

  const [searchIsLoaded, setSearchIsLoaded] = useState(false)

  // Algolia
  useEffect(() => {
    // Load the resources asynchronously.
    loadjs([DOCSEARCH_JS_URL, DOCSEARCH_CSS_URL], () => {
      const inputSelector = '#docsearch-container'
      if (!document.querySelector(inputSelector)) return

      window.docsearch({
        apiKey,
        indexName,
        debug,
        inputSelector
      })

      setSearchIsLoaded(true)
    })
  })

  return (
    <div className={CSS.root}>
      <input
        id='docsearch-container'
        type='search'
        disabled={!searchIsLoaded}
        placeholder={searchIsLoaded ? 'Search...' : ''}
        {...inputProps}
      />
    </div>
  )
}

DocSearch.defaultProps = {
  apiKey: '7df38c7c42979a13050a89b71a66d1a3',
  indexName: 'mashupgarage',
  debug: true,

  /** Props to pass onto <input /> */
  inputProps: {}
}

export default DocSearch
